import { Badge, IconButton } from '@mui/material';
import type { PopperTriggerProps } from '@shared/ui/Popper';
import { Icon } from '@/icon/Icon';

function OpenFilterButton({
  badgeContent,
  onClick,
  disabled,
}: PopperTriggerProps) {
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      size="large"
      sx={{ p: 1 }}
    >
      <Badge badgeContent={badgeContent} color="primary">
        <Icon name="filter" size="small" />
      </Badge>
    </IconButton>
  );
}

export default OpenFilterButton;
